import { defineMessages } from 'react-intl'

export default defineMessages({
  addNew: {
    defaultMessage: 'Add New',
    description: 'Contacts | All new button label',
  },
  addNewFieldLabel: {
    defaultMessage: 'Add new Organisation',
    description: 'Contacts | Add new modal | form field label',
  },
  addNewFieldPlaceholder: {
    defaultMessage: 'Company Bridge ID or Email address',
    description: 'Contacts | Add new modal | form field placeholder',
  },
  addNewHeading: {
    defaultMessage: 'Add a new Contact',
    description: 'Contacts | Add new modal | heading text',
  },
  addNewSubmit: {
    defaultMessage: 'Send request',
    description: 'Contacts | Add new modal | submit button label',
  },
  addNewSubtitle: {
    defaultMessage: 'Connect to an organisation you want to work with',
    description: 'Contacts | Add new modal | heading subtitle',
  },
  allContacts: {
    defaultMessage: 'All Contacts',
    description: 'Contacts | All Contacts tab header',
  },
  pageTitle: {
    defaultMessage: 'Contacts',
    description: 'Contacts | page title',
  },
  required: {
    defaultMessage: 'Required Fields *',
    description: 'Contacts | Add new modal | form legend',
  },
  successMessageBottom: {
    defaultMessage: 'You will be notified when they accept your invitation.',
    description: 'Contacts | on successful adding contact ',
  },
  successMessageTop: {
    defaultMessage: 'Email sent to: {userInput}.',
    description: 'Contacts | on successful adding contact ',
  },
  successModalButtonLabel: {
    defaultMessage: 'Done',
    description: 'Contacts | Add new modal | button label',
  },
  successModalTitle: {
    defaultMessage: 'Connection Request sent',
    description: 'Contacts | Add new modal | title',
  },
})
